import { ProductProps } from '@/@types/common';
import { useAuthContext } from '@/contexts/AuthContext';
import { useUser } from '@/contexts/UserContext';

const buildUrl = (
  baseUrl: string,
  params: { [key: string]: string | undefined }
) => {
  // Filtrar parámetros para asegurarnos de que no haya valores indefinidos
  const filteredParams: Record<string, string> = {};
  Object.keys(params).forEach((key) => {
    const value = params[key];
    if (value !== undefined) {
      filteredParams[key] = value;
    }
  });

  const queryString = new URLSearchParams(filteredParams).toString();
  return `${baseUrl}?${queryString}`;
};

export const ProductLink: React.FC<{
  product: ProductProps;
  target: string;
  children: React.ReactNode;
  setLoading: (loading: boolean) => void;
  additionalParameters?: { [key: string]: string | undefined }; // Agregar propiedad opcional
}> = ({ product, target, children, setLoading, additionalParameters = {} }) => {
  const { userData } = useUser();
  const { refresh, getSession, getEnvironment } = useAuthContext();

  async function executeFunctionAndRedirect() {
    setLoading(true);

    await refresh();
    const session = getSession();
    const environment = getEnvironment();
    const combinedParameters = {
      ...additionalParameters, // Combinar parámetros adicionales
      csrf_token: session?.csrf_token,
      access_token: session?.access_token,
      refresh_token: session?.refresh_token,
      lang: userData?.lang,
      environment: environment ?? undefined,
    };

    const finalUrl = buildUrl(product.baseUrl, combinedParameters);

    const a  = document.createElement('a');
    a.href = finalUrl;
    a.target = target;
    a.click();
    a.remove();

    setLoading(false);
  }

  return (
    <a
      href='#'
      onClick={async (e) => {
        e.preventDefault();
        if (product.enabled || userData?.is_internal) {
          await executeFunctionAndRedirect();
        } else {
          window.open(product.info_url, target, 'noreferrer');
        }
      }}
    >
      {children}
    </a>
  );
};
